import { createLiveMapLoader } from './matchMapApplyController.js';
import { applyTrainingExtraVisibility } from './mapSandboxExtras.js';

/**
 * wireLiveMapLoader — Bind lock-in map reload callbacks without bloating app.js.
 */
export function wireLiveMapLoader({
  mapBounds,
  bushZones,
  wallBoxes,
  impassableZones,
  getTurretRenderObjects,
  matchRuntime,
  mapObjectives,
  scene,
  hudUI,
  turretsUiContainer,
  jungleUiContainer,
  championEntity,
  secondaryChampions,
  attachDamageCallbacks,
  getActiveJungleCamps,
  setActiveJungleCamps,
  gridHelper,
  onTurretsRebuilt,
  onSpawnersRebuilt,
  onPlayerPlaced,
  garenGroup,
  garenPlate,
  dummyGroup,
  dummyPlateDiv,
  sandboxPropGroups,
  _mapSceneState
}) {
  return createLiveMapLoader({
    mapBounds,
    bushZones,
    wallBoxes,
    impassableZones,
    getTurretRenderObjects,
    matchRuntime,
    mapObjectives,
    scene,
    hudUI,
    turretsUiContainer,
    jungleUiContainer,
    championEntity,
    secondaryChampions,
    attachDamageCallbacks,
    getActiveJungleCamps,
    setActiveJungleCamps,
    gridHelper,
    onTurretsRebuilt,
    onSpawnersRebuilt,
    onPlayerPlaced,
    onTrainingExtrasChanged: (mapId) => applyTrainingExtraVisibility({
      mapId,
      garenGroup,
      garenPlate,
      dummyGroup,
      dummyPlateDiv,
      sandboxPropGroups
    }),
    garenGroup,
    garenPlate,
    dummyGroup,
    dummyPlateDiv,
    sandboxPropGroups,
    _mapSceneState
  });
}
